.reconciliation-view-container{display:flex;flex-direction:column;gap:16px;padding:24px}.reconciliation-view-filter{display:flex;align-items:center;gap:8px}.reconciliation-view-table-container{overflow-x:auto}
/*# sourceMappingURL=reconciliation-view.component-XWYEIHG7.css.map */
